import { render } from "./otherHisVoucher.vue?vue&type=template&id=3f318f2a&scoped=true"
import script from "./otherHisVoucher.vue?vue&type=script&lang=js"
export * from "./otherHisVoucher.vue?vue&type=script&lang=js"

import "./otherHisVoucher.vue?vue&type=style&index=0&id=3f318f2a&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f318f2a"]])

export default __exports__